import { AuthFacade } from "@domains/auth/auth.facade";
import { take } from "rxjs/operators";

export function ssoInitializerFactory(authFacade: AuthFacade): () => Promise<void> {
    return async () => {
        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        const error = params.get('error');
        const state = params.get('state');
        const queueItToken = params.get('queueittoken'); //Queue-itからのリダイレクト時はSSOしない

        // ログイン中はSSOしない
        let loggedIn: boolean = false;
        authFacade.loggedIn$.pipe(take(1)).subscribe(value => {
            loggedIn = value;
        });

        // 代理ログインの場合はSSOしない
        let delegateLoggedIn: boolean = false;
        authFacade.delegateLoggedIn$.pipe(take(1)).subscribe(value => {
            delegateLoggedIn = value;
        });

        // 口座情報のコールバックもSSOしない
        const nonRedirectPaths   = [
            '/bankexternal/callback',
        ];
        const isNoneRedirect = nonRedirectPaths.some(p => location.pathname.endsWith(p));

        // 認証コードが無い場合、認可エンドポイントへリダイレクト
        if (!code && !error && !loggedIn && !delegateLoggedIn && !isNoneRedirect && !queueItToken) {
            const requestPath = !state ? location.href.replace(location.origin, '') : state;

            try {
                const silentLoggedIn = await authFacade.silentLogin(requestPath);

                // iPhoneでエラーダイアログが出る対策
                // initializer内でリダイレクトする場合は、即Promiseを完了させてはならない
                // だが、なんらかの理由でリダイレクトされなかった場合は初期化を継続
                // Firefoxの場合は、silentLoggedIn = falseなので、初期化を継続
                if (silentLoggedIn) {
                    await new Promise(resolve => setTimeout(resolve, 5000));    // 5秒待ってから初期化継続
                }
            } catch(e) {
                // なんらかの例外が起きた時は、初期化を継続する
            }
        }
    }
}
